import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { authService } from '../../../../services/auth';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const { t } = useTranslation(['auth', 'common']);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSubmitted(true);
    } catch (error) {
      console.error('Forgot password error:', error);
      setError(error.response?.data?.message || t('auth:forgotPassword.error'));
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-form">
          <div className="success-icon">✓</div>
          <h2 className="forgot-password-title">
            {t('auth:forgotPassword.success_title')}
          </h2>
          <p className="success-message">
            {t('auth:forgotPassword.success_message')}
          </p>
          <div className="form-actions">
            <Link to="/login" className="back-to-login-link">
              {t('auth:forgotPassword.back_to_login')}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-form">
        <h2 className="forgot-password-title">
          {t('auth:forgotPassword.title')}
        </h2>
        <p className="forgot-password-subtitle">
          {t('auth:forgotPassword.subtitle')}
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">
              {t('common:labels.email')}:
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-input"
              placeholder={t('auth:forgotPassword.email_placeholder')}
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !email}
            className="submit-button"
          >
            {loading ? t('common:actionStates.sending') : t('auth:forgotPassword.submit_button')}
          </button>

          <div className="form-actions">
            <Link to="/login" className="back-to-login-link">
              {t('auth:forgotPassword.back_to_login')}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;